<template>
  <v-btn
    :disabled="invalid"
    @click="sendMsg"
    class="ma-auto green lighten-2 white--text"
    block
  >
    <v-icon>mdi-whatsapp</v-icon>&nbsp;Whatsapp
  </v-btn>
</template>

<script>
import { pdfFromQuotation } from "@/services/pdfGenerator";
import { phoneRegex } from "@/helpers/formHelpers";
export default {
  data() {
    return {
      message: null,
      phoneRegex,
    };
  },
  methods: {
    sendMsg() {
      const trimmed = this.phone ? this.phone.trim() : null;
      const valid = this.phoneRegex.test(trimmed);
      if (valid == false) {
        this.$toasted.show(
          "El número de teléfono no es válido. Debe contenter únicamente 10 números",
          { type: "warning" }
        );
        return;
      }
      this.download();
      this.message = `Buen día ${this.clientName}, agradecemos su preferencia y con el gusto de saludarle le enviamos la cotización solicitada`;
      window.open(
        `https://api.whatsapp.com/send?phone=52${this.phone}&text=${this.message}.`,
        "_blank"
      );
    },
    download() {
      pdfFromQuotation(this.$store.state.current);
    },
  },
  computed: {
    phone() {
      return this.$store.state.client.phone;
    },
    invalid() {
      return this.$store.state.invalid;
    },
    clientName() {
      return this.$store.state.client.name ?? "cliente";
    },
  },
};
</script>